/*
 * Jira Ticket:
 * Created Date: Tue, 24th Nov 2020, 13:26:19 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

const farArray = Object.values(far);
const fasArray = Object.values(fas);
const falArray = Object.values(fal);
const fabArray = Object.values(fab);

const icons = [];

// Add regular icons
farArray.forEach(element => {
  icons.push(`far fa-${element.iconName}`);
});
// Add solid icons
fasArray.forEach(element => {
  icons.push(`fas fa-${element.iconName}`);
});
// Add light icons
falArray.forEach(element => {
  icons.push(`fal fa-${element.iconName}`);
});
// Add brand icons
fabArray.forEach(element => {
  icons.push(`fab fa-${element.iconName}`);
});

const fontAwesome = {
  library() {
    library.add(far, fas, fal, fab);
  },
  icons,
};

export default fontAwesome;
